import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../classes/user';
import { BaseService } from './base.service';
import { FilterCrest } from '../classes/filterCrest';

@Injectable({
    providedIn: 'root',
  })
  export class CrestService extends BaseService{
    constructor(http: HttpClient){
        super(http);
        this.entity = 'crest';
    }

  private filterObs$: BehaviorSubject<FilterCrest> = new BehaviorSubject(new FilterCrest());
    getFilterObs(): Observable<FilterCrest> {
        return this.filterObs$.asObservable();
    }
    setFilterObs(filter: FilterCrest) {
          this.filterObs$.next(filter);
    }

  }